import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ClientConsent = () => {
    const navigate = useNavigate();
    const { orderId } = useParams();

    const handleConsent = (consent) => {
        if (consent) {
            navigate(`/checklist/${orderId}/select-zones`);
        } else {
            fetch('https://api.wiseclean.ee/api/decline_quality_check', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ orderId, reason: 'client_declined' }),
            });
            alert('Quality check declined. No photos will be taken.');
            navigate(`/checklist/${orderId}/select-zones`);
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Покажите экран клиенту<br/><br/></h1>
            <h1 style={styles.heading}>Quality Check Notice</h1>
            <p style={styles.text}>
                In accordance with WiseClean quality standards, the cleaner will now conduct
                a cleaning check and take photos to ensure service quality. Photos will not
                be stored on the cleaner&apos;s device and will be securely uploaded to the server
                for automated processing.
            </p>
            <p style={styles.textBold}>
                If you do not consent to this process, please press the button below.
            </p>
            <button style={styles.button} onClick={() => handleConsent(true)}>I Agree</button>
            <button style={{ ...styles.button, backgroundColor: '#000' }} onClick={() => handleConsent(false)}>
                I Do Not Consent
            </button>
        </div>
    );
};

const styles = {
    container: { textAlign: 'center', padding: '20px', maxWidth: '600px', margin: '0 auto' },
    heading: { fontSize: '26px', fontWeight: 'bold', marginBottom: '20px', color: '#000' },
    text: { fontSize: '20px', lineHeight: '1.5', marginBottom: '20px', color: '#333' },
    textBold: { fontSize: '22px', fontWeight: 'bold', color: '#000', marginBottom: '30px' },
    button: {
        width: '90%',
        padding: '20px',
        margin: '10px 0',
        fontSize: '22px',
        borderRadius: '8px',
        border: 'none',
        color: 'white',
        backgroundColor: '#6CC8D9',
        cursor: 'pointer',
    }
};

export default ClientConsent;